import { setSpecificMessage, regex } from "valibot";
setSpecificMessage(
  regex,
  (issue) => `Format invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);